export const optionList = state => state.list;
export const optionOtherAnswer = state => !!state.list.find(option => option.other);



/** WEBPACK FOOTER **
 ** ./src/store/modules/option/getters.js
 **/